/** @format */
/* eslint-disable */ 
export const $_position = {};

export {$_position as default};
